import Logger from '@thales/logger';

export function setLoggerRequestInfo(res) {
  const { config, data } = res;
  const request = { data: config.data, params: config.params };
  Logger.setRequestContext({
    url: res.config.url,
    request,
    response: data,
  });
}

export function setErrLogger(error) {
  Logger.captureException(`ApiError：${error.config.url}`, {error: error.message});
}